import React from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Download, LayoutDashboard, Plus } from "lucide-react";
import { toast } from "sonner";

export default function SuccessPage() {
  const { t } = useLanguage();
  const { formId } = useParams();

  const handleDownload = async () => {
    try {
      const res = await api.get(`/forms/${formId}/pdf`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `USCIS_${formId.slice(0, 8)}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("Failed to download");
    }
  };

  return (
    <div
      data-testid="success-page"
      className="mx-auto max-w-3xl px-6 py-20"
    >
      <div className="hairline bg-card p-10 md:p-14">
        <div className="flex h-14 w-14 items-center justify-center bg-[hsl(var(--primary))]">
          <CheckCircle2 className="h-7 w-7 text-[hsl(var(--primary-foreground))]" strokeWidth={2} />
        </div>
        <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          PDF · {formId?.slice(0, 8)}
        </div>
        <h1 className="mt-3 text-4xl font-black tracking-tight sm:text-5xl">
          {t.success.title}
        </h1>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-muted-foreground">
          {t.success.description}
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button
            onClick={handleDownload}
            data-testid="success-download-button"
            className="h-11 rounded-none bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90"
          >
            <Download className="mr-2 h-4 w-4" />
            {t.success.download}
          </Button>
          <Link to="/wizard" data-testid="success-new-form-link">
            <Button variant="outline" className="h-11 rounded-none border-foreground/40">
              <Plus className="mr-2 h-4 w-4" />
              {t.success.new_form}
            </Button>
          </Link>
          <Link to="/dashboard" data-testid="success-dashboard-link">
            <Button variant="outline" className="h-11 rounded-none border-foreground/40">
              <LayoutDashboard className="mr-2 h-4 w-4" />
              {t.success.dashboard}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
